export default __webpack_public_path__ + "static/media/meeting_step_2.1ba14f9b.svg";